export default __webpack_public_path__ + "static/media/RAMMIS.84c8d00a.webp";